import { Box } from '@chakra-ui/layout';
import { Button, Container, Flex, Spacer, Image, Text } from '@chakra-ui/react';
import React from 'react';

export interface TopNavigationProps {
  handleLogout: () => void;
}
export const TopNavigation = (props: TopNavigationProps): JSX.Element => {
  const { handleLogout } = props;
  return (
    <Box position={'absolute'} left={0} top={0} width={'100%'}>
      <Flex bg={'white'} h={'auto'} boxShadow="lg">
        <Container maxW="container.xl" pl={0} pr={0} pt={2} pb={2}>
          <Flex alignItems={'center'}>
            <Flex flexDirection={{ base: 'row', sm: 'column' }}>
              <Text fontSize={'lg'} fontWeight={'semibold'} color={'gray.600'}>
                Eigentümerverwaltung
              </Text>
            </Flex>
            <Spacer flex={1} />
            <Button onClick={handleLogout} variant={'outline'} colorScheme={'blue'}>
              Abmelden
            </Button>
          </Flex>
        </Container>
      </Flex>
    </Box>
  );
};
